import Name from './_columns/Name';
import Superuser from './_columns/Superuser';
import Revoke from './_columns/Revoke';

export default [
  { id: 'name',        name: 'Staff',     row: Name,        selected: true },
  { id: 'accepted',    name: 'Superuser', row: Superuser,   selected: true },
  { id: 'actions',     name: 'Actions',   row: Revoke,      selected: true }
];
